export const loadingPhrases = [
  'loading_1',
  'loading_2',
  'loading_3',
  'loading_4',
  'loading_5',
  'loading_6',
  'loading_7'
]
